import React from 'react'
import PropTypes from 'prop-types'
import styled, {css} from 'styled-components'
import {Dialog as RmwcDialog} from '@rmwc/dialog'
import '@rmwc/dialog/styles'

export const dialogStyles = ({selector = '&&&'}) => css`
  ${selector} .mdc-dialog__scrim {
    background-color: rgba(var(--mdc-theme-primary2-rgb), 0.9);
  }
  ${selector} .mdc-dialog__surface {
    box-shadow: 0px 4px 8px rgb(0 0 0 / 20%);
  }
`

const StyledRmwcDialog = styled(RmwcDialog)`
  ${dialogStyles}
`

const Dialog = ({children, ...otherProps}) => <StyledRmwcDialog {...otherProps}>{children}</StyledRmwcDialog>

Dialog.propTypes = {
  children: PropTypes.any,
  onClose: PropTypes.func,
  onClosed: PropTypes.func,
  onOpen: PropTypes.func,
  onOpened: PropTypes.func,
  open: PropTypes.bool,
  preventOutsideDismiss: PropTypes.bool
}

export {Dialog}
